import { AuthenticationContext, adalFetch, withAdalLogin } from './helpers/react-adal/react-adal';
import * as types from "./constants/actionTypes";

// To-Do  replace this with serverdata reference
export const adalConfig = {
    tenant: window.serverData.data.azureTenantID,
    clientId: window.serverData.data.activeDirectoryApplicationID,
    endpoints: {
        api: window.serverData.data.activeDirectoryApplicationID,
    },
    cacheLocation: 'sessionStorage',
    postLogoutRedirectUri: window.location.url,
    redirectUri : window.serverData.data.appUrl
};

var context = new AuthenticationContext(adalConfig);
context.onLogout = function () {
    // Possible re-trigger our logout method here
    //alert("Logout");
};
context.onAccessToken = function (accessToken) {
    console.log("Received access token");
    alert("Access token: " + accessToken);
};
context.onIDToken = function (idToken) {
    //debugger;
    let oState = window.store.getState();
    // setup server data first
    console.log("Received updates ID token");
    //debugger;
    store.dispatch({ type: types.SET_AD_ID_TOKEN, idToken: idToken });

    //var sExample = atob(idToken);
    //debugger;
    //alert("ID token: " + idToken);
};

export const authContext = context;
 
export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);
 
export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);
 